// extracted by mini-css-extract-plugin
export default {"link":"Profiles_link__X6JB5"};